
import { SanBackground } from "../../../modules/background/SanBackground";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { Presentation } from "../../../../core/gameflow/controller/Presentation";
import { GameData } from '../../../server/data/GameData';
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { SanQuentin2 } from "../../../SanQuentin2";
import { RevealerManager } from "../../../modules/revealer/RevealerManager";
import { SoundManager } from "../../../config/sound/SoundManager";
import { StateHandler } from "../../../../core/utils/StateHandler";
import { SplashWindows } from "../../../modules/splashScreen/SplashWindows";
import { IntroPresentation } from "../intro/IntroPresentation";
import { SoundConfig } from "../../../config/sound/SoundConfig";

enum BrokeBankState{
    START,
    STOP_GAMBLE,
    STOP_FS,
    STOP,
}

export class BrokeTheBankPresentation extends Presentation {

    private state = new StateHandler(undefined, new Map<any, Function>([
        [ BrokeBankState.START, () => this.onStart() ],
        [BrokeBankState.STOP_GAMBLE, () => this.onGambleEnd()],
        [BrokeBankState.STOP_FS, () => this.onFSEnd()],
        [BrokeBankState.STOP, () => this.onEnd()],
    ]));

    private wonDuringFS:boolean = false;

    public setGameData(data: GameData): void {
        super.setGameData(data);
        this.wonDuringFS = data.isFreeSpin;
    }

    public checkForActivation(data:GameData):boolean{ return data.Win.brokeTheBank};

    preStart(): void {
        this.state.set(BrokeBankState.START);
    }

    public createPresentation(skip:Function){
        skip(false);
        if (SanQuentin2.counter.timeRemaining) {
            this.timeline.to(this, { duration: SanQuentin2.counter.timeRemaining });
            return;
        }

        this.state.triggerState(skip);
    }

    onStart():void {
        SoundManager.stopAmbience();
        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        SanQuentin2.background.showRedLight(false);
        this.timeline.add(SanQuentin2.splashController.play({
            view: SplashWindows.CAP_WINDOW,
            ctnBtnFunc: () => { 
                this.skip();
                if(this._gameData.isFSSetup){
                    this.state.set(BrokeBankState.STOP_GAMBLE);
                }
             },
            data: this._gameData,
        }))
        this.state.set(this._gameData.isFreeSpin ? BrokeBankState.STOP_FS : BrokeBankState.STOP);
    }

    onGambleEnd():void{
        this.outro();

        SanQuentin2.setupPhase.onGambleOutro();
        SanEngineManager.RAll((reel) => reel.reelLocker(false));
        this.setPlayable(false);
    }

    private outro():void{


        SanQuentin2.reelEngineManager.alpha = 1;
        SanQuentin2.background.setBgGFX(0, 0.2);
        SanQuentin2.reelEngineManager.returnToBase();
        IntroPresentation.playIntroAnimation(this.timeline);
        SanQuentin2.background.triggerTransition(false);

        SanQuentin2.xWaysCounter.hide();
        SanQuentin2.overlay.hideLogo();
        SoundManager.playSoundEffect(SoundConfig.FS_OUTRO_BUSS);
        this.timeline.add(() => { 
            SanQuentin2.xWaysCounter.counterActive(true,false);
            SanQuentin2.overlay.introApplyLogo();
        })

    }

    onFSEnd():void{
        this.setPlayable(false);
        this.outro();
        // SanQuentin2.reelEngineManager.setFSReelAreaBG(false);
        // const durr = SanQuentin2.background.triggerTransition(false);
        // this.timeline.to(this,{duration:durr});
    }

    onEnd():void{ // Animation
        this.setPlayable(false);
    }

    done():void{
        SanQuentin2.jumpingWildController.CleanAndReset();
        RevealerManager.setSpecialData("",0);
        SoundManager.PlayAmbience(SoundConfig.BASE_GAME_AMBIANCE);
        SanEngineManager.RAll(reel => reel.setCurrentReelSet());
    }
}